import React from 'react'
export default function AlertBox({amessage, acolor, show}){
  console.log("Hello from AlertBox");
  return <div className={"alertify "+(show?"showalert":"")} style={{background: acolor}}>{amessage}</div>
}